import { Model } from "vue-mc";

export class Localidad extends Model {
  defaults() {
    return {
      clave: null
      , codigo: ""
      , nombre: ""
      , codigopostal: []
      , provincia: null
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , codigo: (codigo) => codigo
      , nombre: (nombre) => nombre
      , codigopostal: (codigopostal) => codigopostal
      , provincia: (provincia) => provincia
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/models/geograficos/localidad.js